var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfServiceSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5630",
    "data-name": "Group 5630",
    transform: "translate(-305.375 -477)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_860",
    "data-name": "Ellipse 860",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(305.375 477)",
    fill: "#ceeefb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5646",
    "data-name": "Group 5646",
    transform: "translate(318.875 489.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28984",
    "data-name": "Path 28984",
    d: "M8,12h8M8,12c0-.7,1.994-2.008,2.5-2.5M8,12c0,.7,1.994,2.009,2.5,2.5",
    fill: "none",
    stroke: "#3e90b1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28985",
    "data-name": "Path 28985",
    d: "M2.5,12c0-4.478,0-6.718,1.391-8.109S7.522,2.5,12,2.5s6.718,0,8.109,1.391S21.5,7.522,21.5,12s0,6.718-1.391,8.109S16.478,21.5,12,21.5s-6.718,0-8.109-1.391S2.5,16.478,2.5,12Z",
    fill: "none",
    stroke: "#3e90b1",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfServiceSignup);
export default __webpack_public_path__ + "static/media/self_service_signup.3b103e39c2b457502b9e393d3ab68524.svg";
export { ForwardRef as ReactComponent };